import tippy, { Instance, Props } from 'tippy.js';
import { I18nHelper, Translations } from "../../../Lib/Helper/I18nHelper";
import { PriceHelper } from "../../../Lib/Helper/PriceHelper";
import { AxCounter } from "../../../Limestone/AxCounter/AxCounter";
import { AxLoading } from "../../../Limestone/AxLoading/AxLoading";
import { LandingQuickSelection, QuickSelectionQuantityCounter } from '../LandingQuickSelection';

export class QuantitySelection {
    public quantitySelectionTippy: Instance<Props>;
    private _mainModule: LandingQuickSelection;

    constructor(
        private _i18nHelper = new I18nHelper(),
        private _axLoading = new AxLoading(),
        private _priceHelper = new PriceHelper(null, false),
    ) { }

    init(mainModule: LandingQuickSelection) {
        this._mainModule = mainModule;
        this.quantitySelectionTippy = tippy(document.querySelector('.ax-store-hero_title_and_searchBarHolder .searchbar-wrapper'), {
            allowHTML: true,
            interactive: true,
            content: document.querySelector('[data-tv4-quickselection--dropdown-quantity="popup"]'),
            placement: 'bottom-end',
            arrow: false,
            trigger: 'manual',
            maxWidth: 'none',
            appendTo: () => document.body,
            onShow(instance) {
                instance.popper.style.width = $('.ax-store-hero_title_and_searchBarHolder .searchbar-wrapper')
                    ?.get(0)
                    .getBoundingClientRect().width / 100 * 60 + 'px';
                $(window).on('scroll', () => instance.hide());
            },
        });

        $('[data-tv4-quickselection--dropdown="quantity"]').on('click', (e) => {
            if (!$(e.delegateTarget).attr('disabled')) {
                this.quantitySelectionTippy.show();
            }
        });
    }

    getQuantitySelection(date: moment.Moment) {
        this._mainModule.prodDropdown.getElements().attr('disabled', null);
        this._mainModule.dateDropdown.getElements().attr('disabled', null);
        this._mainModule.quantityDropdown.getElements().attr('disabled', null);

        $('[data-tv4-quickselection--dropdown="quantity"] .ax-dropdown__icon')
            .removeClass('la-user')
            .addClass('la-circle-notch la-spin ax-p-0 ax-mt-1-n ax-ml-1');

        const $popperProdPopper = this._mainModule.getPopper(this._mainModule.prodDropdown);
        const $selectedOption = $($popperProdPopper.find('.ax-dropdown__item.selected'));

        const isPredatable = !$('[data-tv4-quickselection--dropdown="date"]').hasClass('d-none');

        this._axLoading.ShowLoadingIndicator($('[data-tv4-quickselection="overlay"]')[0]);

        if (isPredatable) {
            this._axLoading.ShowLoadingIndicator($('[data-tv4-quickselection--dropdown="date"]')[0]);
        }

        $('[data-tv4-quickselection--overlay="quantity"]').html('');

        let openOnLoad = this._mainModule.initComplete;
        AxessViewer.loadPartialView(
            `${$selectedOption.attr('data-link')}?date=${date.format('YYYY-MM-DD')}`,
            {},
            (resp) => {
                this._mainModule.counter = [];

                const div = document.createElement('div');
                div.innerHTML = resp.trim();
                const $resp = $(div);
                const isSingleSelection = $resp.find('[data-display="single"]').length > 0;
                const desktopContent = $resp.find('[data-target="desktop"]')[0].cloneNode(true);
                const $desktopCounter = $(desktopContent).find('[data-tv4-quickselection--dropdown-quantity="counter"]');

                if (isSingleSelection) {
                    //@ts-ignore
                    $('[data-tv4-quickselection--dropdown="quantity-single"]').html(desktopContent);
                    $(`[data-tv4-quickselection--dropdown="quantity"]`).addClass('d-none');
                } else {
                    $('[data-tv4-quickselection--dropdown="quantity-single"]').html('');
                    $(`[data-tv4-quickselection--dropdown="quantity"]`).removeClass('d-none');
                    $(this.quantitySelectionTippy.popper)
                        .find('[data-tv4-quickselection--dropdown-quantity="popup"]')
                        //@ts-ignore
                        .html(desktopContent);
                }

                $('[data-tv4-quickselection--overlay="quantity"]')
                    .html(
                        //@ts-ignore
                        $resp.find('[data-target="mobile"]')?.get(0).cloneNode(true)
                    );

                $('[data-tv4-quickselection--dropdown="quantity"] .ax-dropdown__icon')
                    .removeClass('la-circle-notch la-spin ax-p-0 ax-mt-1-n ax-ml-1')
                    .addClass('la-user');

                for (let elem of $desktopCounter) {
                    this.initCounter(elem, 'desktop');
                }
                for (let elem of $('[data-tv4-quickselection--overlay="quantity"]').find('[data-tv4-quickselection--dropdown-quantity="counter"]')) {
                    this.initCounter(elem, 'mobile');
                }

                const desktopFilter = this._mainModule.counter.filter(x => x.mode === 'desktop');
                if (desktopFilter.length === 1 && !openOnLoad && desktopFilter[0].counter.GetValue() == 0) {
                    desktopFilter[0].counter.IncreaseQuantity();
                }

                setTimeout(() => {
                    for (let elem of $desktopCounter) {
                        const $elem = $(elem);
                        const quantity = parseInt($elem.find('[data-quantity-selection]').html(), 10);
                        const subTypeIdentifier = parseInt($(elem).attr('data-subtypeidentifier'));
                        this.adjustPrice(subTypeIdentifier, quantity);
                    }
                }, 200);

                //Only for predatable put the message content for closing days.
                if (isPredatable) {
                    this._axLoading.HideLoadingIndicator($('[data-tv4-quickselection--dropdown="date"]')[0]);
                    const extendedClosingDaysSpan = $resp.find('[data-extended-closing-days]');
                    if (extendedClosingDaysSpan) {
                        const extendedClosingDates = extendedClosingDaysSpan.get(0)?.innerHTML?.trim()?.split('|');
                        const blockedDates = extendedClosingDates?.map(x => moment(x, "YYYY-MM-DD"));

                        for (let date of blockedDates) {
                            if (this.isMobileDevice()) {
                                this._mainModule.mobileInterface.datePickerMobile.BlockDate((date));
                            }
                            else {
                                this._mainModule.datePicker.BlockDate(date);
                            }
                        }

                        const messageDiv = $resp.find('[data-message-closing-day]');
                        if (messageDiv.length) {
                            if (!this.isMobileDevice()) {
                                //Open date dropdown only for desktop
                                this._mainModule.dateDropdown.open();
                            }
                            //Set the message content
                            $('[data-message-closing-day-datepicker]').html(messageDiv.get(0)?.outerHTML ?? null);
                        }
                    }
                }

                this._mainModule.mobileInterface.renderSubmitButtonText();

                if (openOnLoad && !isSingleSelection) {
                    this.quantitySelectionTippy.show();
                }
                this._axLoading.HideLoadingIndicator($('[data-tv4-quickselection="overlay"]')[0]);
            }, {
            responseIsHTML: true,
            addCulturInfo: false,
        });
    }

    adjustPrice(subTypeIdentifier: number, quantity: number) {
        let $priceElements = $(`[data-subtypeidentifier--copy="${subTypeIdentifier}"] [data-price]:checked`);

        let total = parseInt($(`[data-subtypeidentifier="${subTypeIdentifier}"] [data-base-price]`).attr('data-base-price')) * quantity;

        for (let priceElem of $priceElements) {
            total += parseInt($(priceElem).attr('data-price'));
        }

        let $sumElem = $(`[data-subtypeidentifier="${subTypeIdentifier}"] [data-calculated-price]`);
        $sumElem.html(this._priceHelper.GetPriceString(total / 100));
    }

    renderQuantityLines(subTypeIdentifier: number, quantity: number) {
        this.desktopQuantityLines(subTypeIdentifier, quantity);
        this.mobileQuantityLines(subTypeIdentifier, quantity);

        let totalSum = 0;
        for (let c of this._mainModule.counter.filter(x => x.mode === 'desktop')) totalSum += c.counter.GetValue();
        if (totalSum > 0) {
            this._mainModule.quantityDropdown.setValue(this._i18nHelper.GetTranslation(Translations.TicketsX,
                totalSum));
        } else {
            this._mainModule.quantityDropdown.setValue(this._i18nHelper.GetTranslation(Translations.QuantityTicket));

        }
    }

    mobileQuantityLines(subTypeIdentifier: number, quantity: number) {
        const elementsToCopy: HTMLElement[] = [];
        const $popper = $('[data-tv4-quickselection--overlay="quantity"]');
        const $articleQuantity = $popper.find(`[data-tv4-quickselection--dropdown-quantity="article"][data-subtypeidentifier=${subTypeIdentifier}]`);

        $popper.find(`[data-subtypeidentifier--copy=${subTypeIdentifier}]`).remove();

        for (let elem of $articleQuantity) {
            elementsToCopy.push(elem);
        }

        const lastSelectionElement = $popper
            .find(`[data-tv4-quickselection--dropdown-quantity="article"][data-subtypeidentifier=${subTypeIdentifier}]`)
            .not('[data-subtypeidentifier--copy]')
            .last();
        elementsToCopy.reverse();

        for (let i = 0; i < quantity; i++) {
            let separator = document.createElement('div');
            separator.style.borderBottom = "1px solid #C7C7C7";
            separator.style.gridColumn = "1/5";
            separator.classList.add('ax-mx-2-n');
            separator.setAttribute('data-subtypeidentifier--copy', subTypeIdentifier.toString());

            for (let elem of elementsToCopy) {
                let $elemC = $(elem.cloneNode(true));
                $elemC.find('[data-tv4-quickselection--dropdown-quantity="article-index"]').html(`${quantity - i}.`);
                $elemC.removeClass('d-none');
                $elemC.attr('data-subtypeidentifier--copy', subTypeIdentifier);
                $elemC.attr('data-subtypeidentifier', null);

                $elemC.find('input[type=checkbox]').on('change',
                    () => {
                        this.adjustPrice(subTypeIdentifier, quantity);
                    });

                //@ts-ignore
                $(lastSelectionElement).after($elemC);
            }
            $(lastSelectionElement).after(separator);
        }
    }

    desktopQuantityLines(subTypeIdentifier: number, quantity: number) {
        let elementsToCopy: HTMLElement[] = [];
        let $popper = $(this.quantitySelectionTippy.popper);

        $popper
            .find(`[data-tv4-quickselection--dropdown-quantity="popup"] [data-subtypeidentifier--copy=${subTypeIdentifier}]`)
            .remove();

        if (quantity - 1 < 1) return;

        if ($(`[data-tv4-quickselection--dropdown-quantity="popup"] [data-subtypeidentifier=${subTypeIdentifier}][data-tv4-quickselection--dropdown-quantity="article"]`).length === 0) return;

        for (let elem of $popper.find(`[data-tv4-quickselection--dropdown-quantity="popup"] [data-subtypeidentifier=${subTypeIdentifier}]`)) {
            elementsToCopy.push(elem);
        }
        elementsToCopy[elementsToCopy.length - 1] = document.createElement('div');

        const lastSelectionElement = $popper
            .find(`[data-tv4-quickselection--dropdown-quantity="popup"] [data-subtypeidentifier=${subTypeIdentifier}]`)
            .last();
        elementsToCopy.reverse();

        for (let i = 0; i < quantity - 1; i++) {
            let separator = document.createElement('div');
            separator.style.borderBottom = "1px dashed #C7C7C7";
            separator.style.gridColumn = "1/5";
            separator.classList.add('ax-mx-2-n');
            separator.setAttribute('data-subtypeidentifier--copy', subTypeIdentifier.toString());

            for (let elem of elementsToCopy) {
                let $elemC = $(elem.cloneNode(true));
                $elemC.attr('data-subtypeidentifier--copy', subTypeIdentifier);
                $elemC.attr('data-subtypeidentifier', null);
                //@ts-ignore
                $(lastSelectionElement).parent().after($elemC);
            }
            $(lastSelectionElement).parent().after(separator);
        }
    }

    initCounter(elem: HTMLElement, mode: "desktop" | "mobile") {
        const $elem = $(elem);
        const quantity = parseInt($elem.find('[data-quantity-selection]').html(), 10);
        const subTypeIdentifier = parseInt($(elem).attr('data-subtypeidentifier'));

        const axCounter = new AxCounter();
        axCounter.Init({
            Value: quantity,
            Selector: elem,
            Max: parseInt($elem.attr('data-max') ?? "10"),
            Min: parseInt($elem.attr('data-min') ?? "0"),
        });
        axCounter.Subscribe((x) => {
            const subTypeIdentifier = parseInt($(elem).attr('data-subtypeidentifier'), 10);
            this.renderQuantityLines(subTypeIdentifier, x);
            this.adjustPrice(subTypeIdentifier, x);
            this._mainModule.mobileInterface.renderSubmitButtonText();
        });

        this.renderQuantityLines(subTypeIdentifier, quantity);
        const tmp: QuickSelectionQuantityCounter = {
            counter: axCounter,
            mode: mode,
        };

        this._mainModule.counter.push(tmp);
    }

    isMobileDevice(): boolean {
        const devicesToMatch = [
            /Android/i,
            /webOS/i,
            /iPhone/i,
            /iPad/i,
            /iPod/i,
            /BlackBerry/i,
            /Windows Phone/i
        ];

        return devicesToMatch.some((x) => {
            return navigator.userAgent.match(x);
        });
    }

}